import { Icon } from "dash-ui";
import { Trans, useTranslation } from "react-i18next";
import { PaymentMethod } from "../SubscriptionChangeConfirmationModalV2.interfaces";

const REST_API_DOMAIN = process.env["REACT_APP_REST"];

interface PaymentMethodSectionProps {
  paymentMethod?: PaymentMethod;
  stripeCustomerId?: string;
  compact?: boolean;
}

export default function PaymentMethodSection({
  paymentMethod,
  stripeCustomerId,
  compact,
}: PaymentMethodSectionProps) {
  const { t } = useTranslation(["pages", "common"]);
  return (
    <>
      <div className={compact ? "mb-3" : "mb-5"}>
        <div className="flex justify-between items-center py-3 px-3 rounded-lg bg-gray-50 border border-gray-200">
          <span className="text-sm text-gray-500">
            {t("pages:profilePage.billing.invoicePreview.paymentMethod")}
          </span>
          <div className="flex items-center gap-2">
            {paymentMethod ? (
              <>
                <Icon name="creditCard" size={16} color="#64748b" />
                <span className="text-sm text-gray-900">
                  {paymentMethod.cardBrand.toUpperCase()} ••••{" "}
                  {paymentMethod.cardNumber.slice(-4)}
                </span>
                <a
                  href={`${REST_API_DOMAIN}/stripe/create-portal-session?customerId=${stripeCustomerId}`}
                  className="text-sm hover:opacity-80 ml-1 underline underline-offset-2"
                  style={{ color: "#1B75BB" }}
                >
                  {t("common:labels.change")}
                </a>
              </>
            ) : (
              <span className="text-red-600 text-sm">
                {t("pages:profilePage.billing.changeConfirm.noPaymentMethod")}
              </span>
            )}
          </div>
        </div>
      </div>

      <hr className={`border-gray-100 ${compact ? "mb-3" : "mb-5"}`} />

      {!paymentMethod && (
        <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-sm text-yellow-800">
            <Trans
              i18nKey="pages:profilePage.billing.invoicePreview.addPaymentMethodWarning"
              components={{
                link: (
                  <a
                    className="underline hover:opacity-80 font-medium"
                    href={`${REST_API_DOMAIN}/stripe/create-portal-session?customerId=${stripeCustomerId}`}
                  />
                ),
              }}
            />
          </p>
        </div>
      )}
    </>
  );
}
